export const ROUTES = {
  home: "/",
  login: "/Login",
  about: "/about-us",
  camps: "/camps",
  registerForm: "/register-form",
  iscb: "/iscb",
  registeredPlayers: "/registered-players",
  editProfile: "/edit_profile",
  terms: "/terms&conditions",
  privacy: "/privacy-policy",
  refundPolicy: "/pricing-and-refund-policy",
  isbcIntro: "/isbc-intro",
  mobilePrivacy: "/privacy-policy-isbc",
};

export const routeWithId = {
  student: (id) => `/student/${id}`,
  payment: (id) => `/payment/${id}`,
  easeBuzz: (id) => `/ease-buzz/${id}`,
  campsList: (id) => `/camps-list/${id}`,
  committeeMember: (id) => `/committee-members/${id}`,
};
